/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, Fragment } from "react";
import {
  UploadIcon,
  SearchIcon,
  DownloadIcon,
  XIcon,
  ChevronDownIcon,
} from "@heroicons/react/solid";
import { CloudUploadIcon, MenuIcon } from "@heroicons/react/outline"; // Added MenuIcon, XIcon
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import useState from "react-usestateref";
import ReactTooltip from "react-tooltip";
import { Menu, Transition } from "@headlessui/react";
import { useFileUpload } from "use-file-upload";
import useDownloader from "react-use-downloader";
import "./Friends.css";
import { toast } from "react-toastify";
import axios from "axios";
import backendService from "../services.js/backendService";
import TimeAgo from "timeago-react";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "react-query";
import ConfirmationDeleteFile from "./ConfirmationDeleteFile";
import { ShimmerPostItem } from "react-shimmer-effects";
import {
  initializeFileTypeIcons,
  getFileTypeIconProps,
} from "@fluentui/react-file-type-icons";
import { Icon } from "@fluentui/react/lib/Icon";
import ShareFileModal from "./ShareFileModal";
import FIlePreviewModal from "./FilePreviewModal";
import UploadFileModal from "./UploadFileModal";
import RunCodeModal from "./RunCodeModal";
import FlipMove from "react-flip-move";
import {
  languages,
  getCompilerCodeByExtension,
  isExtensionCodeFile,
  urlToBlob,
  blobToString,
} from "./CodingLanguageList";
import ViewCodeModal from "./ViewCodeModal";
initializeFileTypeIcons();

const sufixes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
const getBytes = (bytes) => {
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return (
    (!bytes && "0 Bytes") ||
    (bytes / Math.pow(1024, i)).toFixed(1) + "" + sufixes[i]
  );
};
function truncate(string, n) {
  return string?.length > n ? string.substr(0, n - 1) + " ..." : string;
}

function QuipComponent() {
  return <ShimmerPostItem imageWidth={80} imageHeight={80} card title cta />;
}
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
async function handleCodeSpace() {
  try {
    const response = await axios.get(`${process.env.REACT_APP_URL}/getallfiles`, {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": backendService.getToken(),
      },
    });
    return response.data.files;
  } catch (error) {
    return error.response;
  }
}

function CodeSpace(props) {
  const [chevronIcon, setChevronIcon] = useState(false);
  const [file, selectFile] = useFileUpload();
  const queryClient = useQueryClient();
  const { data, status, refetch } = useQuery("codespace", handleCodeSpace, {
    retry: true,
  });
  const { size, elapsed, percentage, download, cancel, error, isInProgress } =
    useDownloader();
  const [currentFile, setCurrentFile] = useState(null);
  const [deleteFileBoxState, setDeleteFileBoxState] = useState(false);
  const [shareFileModalState, setShareFileModalState] = useState(false);
  const [filePreviewModalState, setFilePreviewModalState] = useState(false);
  const [uploadFileModalState, setUploadFileModalState] = useState(false);
  const [showCodeRunModal, setShowCodeRunModal] = useState(false);
  const [openViewCodeModal, setOpenViewCodeModal] = useState(false);
  const [codeData, setCodeData, codeDataRef] = useState(null);
  const getShareFileModalState = (state) => {
    setShareFileModalState(state);
  };
  const getDeleteFileBoxState = (data) => {
    setDeleteFileBoxState(data);
    refetch();
  };
  const getFilePreviewModalState = (data) => {
    setFilePreviewModalState(data);
  };
  const getUploadFileModalState = (data) => {
    setUploadFileModalState(data);
    refetch();
  };
  const openCodeRunModal = (data) => {
    setShowCodeRunModal(data);
    
  };
  const codeRunModal = () => {
    
    return (
      <RunCodeModal
        openCodeRunModal={openCodeRunModal}
        codeData={codeDataRef.current}
      />
    );
  };
  const [searchedFiles, setSearchedFiles] = useState([]);
  const [searchText, setSearchText, searchTextRef] = useState("");

  useEffect(() => {
    if (data) {
      setSearchedFiles(data);
    }
  }, [data]);

  useEffect(() => {
    if (searchTextRef.current.length > 0) {
      const filteredFiles = data.filter((file) =>
        file.fileOGName
          .toLowerCase()
          .includes(searchTextRef.current.toLowerCase())
      );
      setSearchedFiles(filteredFiles);
    }
  }, [searchText]);

  const deleteFileDB = () => {
    return (
      <ConfirmationDeleteFile
        openDeleteMessageAlert={getDeleteFileBoxState}
        id={currentFile._id}
      />
    );
  };

  const shareFileDB = () => {
    return (
      <ShareFileModal
        openShareFileModal={getShareFileModalState}
        fileId={currentFile._id}
        getForwardMessage={props.getForwardMessage}
        getCurrent={props.getCurrent}
      />
    );
  };

  const filePreviewDB = () => {
    return (
      <FIlePreviewModal
        openFileViewerModal={getFilePreviewModalState}
        File={currentFile}
      />
    );
  };
  const viewCodeModel = () => {
    return (
      <ViewCodeModal
        openViewCodeModal={setOpenViewCodeModal}
        codeData={codeDataRef.current}
      />
    );
  };
  const uploadFileDB = () => {
    return <UploadFileModal openUploadFileModal={getUploadFileModalState} />;
  };
  return (
    <>
      {deleteFileBoxState && deleteFileDB()}
      {shareFileModalState && shareFileDB()}
      {filePreviewModalState && filePreviewDB()}
      {uploadFileModalState && uploadFileDB()}
      {showCodeRunModal && codeRunModal()}
      {openViewCodeModal && viewCodeModel()}
      <div className="flex flex-col w-full h-screen select-none bg-background">
        <ReactTooltip delayShow={500} delayHide={100} />
        {/* Header start */}
        <div className="flex items-center h-[60px] px-3 sm:px-5"> {/* Modified classes */}
          {props.setIsMobileMenuOpen && (
            <div className="mr-3 sm:hidden">
              <button onClick={() => props.setIsMobileMenuOpen(!props.isMobileMenuOpen)} className="p-1 text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500">
                {props.isMobileMenuOpen ? <XIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
              </button>
            </div>
          )}
          <h3 className="flex-grow min-w-0 overflow-hidden text-xl text-primary sm:text-2xl font-robo whitespace-nowrap text-ellipsis">Code Space</h3>
          <div
            className="flex items-center justify-center cursor-pointer h-7 w-7 text-palette_color1 hover:bg-palette_color1 hover:text-palette_color2 hover:rounded-full"
            data-tip="Upload Files"
            data-place="right"
            onClick={() => {
              setUploadFileModalState(true);
            }}
          >
            <CloudUploadIcon
              className="w-5 h-5 cursor-pointer"
              aria-hidden="true"
            />
          </div>
        </div>
        {/* Header end */}
        {/* Search Bar Start */}
        <div className="hidden md:block">
          <div className="flex items-center h-16 px-5  bg-background">
            <ReactTooltip delayShow={500} delayHide={100} />
            <div
              className="relative items-center w-full"
              data-tip="Enter text to search"
              data-place="bottom"
            >
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                <SearchIcon
                  className="absolute w-6 h-6 text-palette_color1"
                  aria-hidden="true"
                />
              </div>
              <input
                type="text"
                name="search"
                id="search"
                autoComplete="off"
                className="font-robo block text-sm w-full pl-10 py-2 px-3 bg-palette_color2 text-primary appearance-none border-[1px] border-palette_color1 rounded-xl placeholder-secondary focus:outline-none focus:z-10 sm:text-sm"
                placeholder="Search"
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        {/* Search Bar End */}
        {/* File Section Start */}
        {status === "loading" ? (
          <div className="flex flex-wrap items-start justify-between w-full overflow-y-auto o scrollbar-track-pallete_color3 overflow-x-hidden scroll-smooth chat__container h-[100%] row_Overflow p-3">
            <div className="relative flex flex-col justify-around h-30 w-full md:w-[48%] cursor-pointer hover:bg-hover hover:rounded-lg my-3">
              <div className="flex flex-col items-center justify-center ">
                <QuipComponent />
              </div>
            </div>
            <div className="relative flex flex-col justify-around h-30 w-full md:w-[48%] cursor-pointer hover:bg-hover hover:rounded-lg  my-3">
              <div className="flex flex-col items-center justify-center">
                <QuipComponent />
              </div>
            </div>
            <div className="relative flex flex-col justify-around h-30 w-full md:w-[48%] cursor-pointer hover:bg-hover hover:rounded-lg my-3">
              <div className="flex flex-col items-center justify-center">
                <QuipComponent />
              </div>
            </div>
            <div className="relative flex flex-col justify-around h-30 w-full md:w-[48%] cursor-pointer hover:bg-hover hover:rounded-lg  my-3">
              <div className="flex flex-col items-center justify-center">
                <QuipComponent />
              </div>
            </div>
          </div>
        ) : status === "error" ? (
          <div className="flex items-center justify-center h-full">
            <h3 className="text-3xl tracking-widest text-primary font-proxima">
              {data.message}
            </h3>
          </div>
        ) : (
          <div className="flex flex-wrap items-start justify-between w-full overflow-y-auto  scrollbar-track-pallete_color3 overflow-x-hidden scroll-smooth chat__container h-[100%] row_Overflow p-3">
            {/* This div contains chevronIcon, and folder icon, name and size section. This whole div will be mapped when backend will be connected. */}
            {searchTextRef.current.length > 0 ? (
              searchedFiles.length > 0 ? (
                searchedFiles.map((file, index) => (
                  <div
                    className="relative flex flex-col justify-around h-auto w-full md:w-[48%] lg:w-[47%] p-3 sm:p-4 cursor-pointer hover:bg-palette_color1 text-primary hover:text-palette_color2 hover:rounded-lg"
                    onMouseEnter={() =>
                      setChevronIcon({
                        id: file._id,
                        state: true,
                      })
                    }
                    onMouseLeave={() => setChevronIcon(false)}
                    onDoubleClick={async () => {
                      if (!isExtensionCodeFile(file?.fileExtension)) {
                        setCurrentFile(file);
                        setFilePreviewModalState(true);
                      }
                      {
                        const blobObj = await urlToBlob(file?.filePath);
                        const dataString = await blobToString(blobObj);

                        setCodeData({
                          script: dataString,
                          language: getCompilerCodeByExtension(
                            file?.fileExtension
                          ).LanguageCode,
                        });
                        setOpenViewCodeModal(true);
                      }
                    }}
                  >
                    {chevronIcon && chevronIcon?.id === file._id && (
                      <div className="absolute top-0 right-0 m-3">
                        <Menu
                          as="div"
                          className="relative inline-block text-left "
                        >
                          <div>
                            <Menu.Button>
                              <div className="flex items-center justify-center h-7 w-7 text-palette_color2 hover:bg-palette_color2 hover:text-palette_color1 hover:rounded-full">
                                <ChevronDownIcon
                                  className="w-5 h-5 "
                                  aria-hidden="true"
                                />
                              </div>
                            </Menu.Button>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items
                              className={
                                index & 1
                                  ? "origin-top-center absolute left-[-150px] mt-1 w-44 rounded-md shadow-md shadow-black bg-palette_color2 focus:outline-none z-10"
                                  : "origin-top-center absolute left-0 mt-1 w-44 rounded-md shadow-md shadow-black bg-palette_color2 focus:outline-none z-10"
                              }
                            >
                              {" "}
                              {isExtensionCodeFile(file?.fileExtension) && (
                                <Menu.Item>
                                  {({ active }) => (
                                    <a
                                      href="#"
                                      className={classNames(
                                        active
                                          ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                          : "text-palette_color1",
                                        "block px-4 py-2 text-sm font-robo "
                                      )}
                                      onClick={async () => {
                                        const blobObj = await urlToBlob(
                                          file?.filePath
                                        );
                                        const dataString = await blobToString(
                                          blobObj
                                        );

                                        setCodeData({
                                          script: dataString,
                                          language: getCompilerCodeByExtension(
                                            file?.fileExtension
                                          ).CompilerCode,
                                        });
                                        if (
                                          getCompilerCodeByExtension(
                                            file?.fileExtension
                                          ).CompilerCode === "Not Supported"
                                        ) {
                                          toast.error(
                                            "This language is not supported"
                                          );
                                        } else {
                                          setShowCodeRunModal(true);
                                        }
                                      }}
                                    >
                                      Run
                                    </a>
                                  )}
                                </Menu.Item>
                              )}
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active
                                        ? "bg-palette_color1 text-palette_color2 "
                                        : "text-palette_color1",
                                      "block px-4 py-2 text-sm font-robo "
                                    )}
                                    onClick={() => {
                                      setCurrentFile(file);
                                      setShareFileModalState(true);
                                    }}
                                  >
                                    Share
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active
                                        ? "bg-palette_color1 text-palette_color2 "
                                        : "text-palette_color1",
                                      "block px-4 py-2 text-sm font-robo "
                                    )}
                                    onClick={() => {
                                      if (isInProgress) {
                                        toast.error("Download is in progress", {
                                          theme: "light",
                                        });
                                      } else {
                                        setCurrentFile(file);
                                        download(
                                          file.filePath,
                                          file.fileOGName
                                        );
                                      }
                                    }}
                                  >
                                    Download
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active
                                        ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                                        : "text-palette_color1",
                                      "block px-4 py-2 text-sm font-robo "
                                    )}
                                    onClick={() => {
                                      setCurrentFile(file);
                                      setDeleteFileBoxState(true);
                                    }}
                                  >
                                    Delete
                                  </a>
                                )}
                              </Menu.Item>
                            </Menu.Items>
                          </Transition>
                        </Menu>
                      </div>
                    )}
                    {/* Folder Icon and Folder name, size Section Start */}
                    <div className="flex flex-col items-center justify-center">
                      {isInProgress && currentFile._id === file._id ? (
                        <>
                          <div className="relative flex flex-row">
                            <div className="flex items-center justify-center">
                              <div className="flex items-center justify-center">
                                <CircularProgressbar
                                  className="rounded-full h-9 w-9 "
                                  value={percentage}
                                  strokeWidth={11}
                                  styles={buildStyles({
                                    // pathColor: "turquoise",
                                    // trailColor: "gold",
                                    textSize: "20px",
                                  })}
                                  //text={`${percentage}%`}
                                />
                              </div>
                              <div
                                className="absolute flex items-center justify-center"
                                onClick={() => cancel()}
                              >
                                <XIcon className="w-5 h-5 cursor-pointer text-icon_color" />
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <Icon
                          {...getFileTypeIconProps({
                            extension: file?.fileExtension,
                          })}
                          className="w-16 h-16 mx-auto cursor-pointer sm:h-20 sm:w-20 md:h-24 md:w-24 "
                        />
                      )}
                      <div className="flex items-center justify-center space-x-1">
                        <h3 className="text-sm  font-robo">
                          {truncate(file?.fileOGName, 20)}
                        </h3>
                      </div>
                      <div className="flex flex-row items-center justify-between space-x-1">
                        <h4 className="  font-robo text-[0.6rem]">
                          <TimeAgo datetime={file?.createdAt} />
                        </h4>
                        <h4 className="  font-robo text-[0.6rem]">
                          {getBytes(file?.fileSize)}
                        </h4>
                      </div>
                    </div>
                    {/* Folder Icon and Folder name, size Section End */}
                  </div>
                ))
              ) : (
                <div className="flex flex-col items-center justify-center w-full">
                  <p className="mt-10 text-xl font-semibold text-primary font-robo">
                    No Files Found
                  </p>
                  <button
                    className="px-6 py-3 my-3 mb-1 mr-1 text-white uppercase transition-all duration-500 ease-linear rounded shadow-sm  bg-palette_color1 hover:bg-palette_color2 hover:text-palette_color1 font-robo text-md hover:border hover:border-palette_color1 hover:shadow-lg"
                    type="button"
                    onClick={() => setUploadFileModalState(true)}
                  >
                    Upload file
                  </button>
                </div>
              )
            ) : data && data.length > 0 ? (
              data?.map((file, index) => (
                <div
                  className="relative flex flex-col justify-around h-auto w-full md:w-[48%] lg:w-[47%] p-3 sm:p-4 cursor-pointer hover:bg-palette_color1 text-primary hover:text-palette_color2 hover:rounded-lg"
                  onMouseEnter={() =>
                    setChevronIcon({
                      id: file._id,
                      state: true,
                    })
                  }
                  onMouseLeave={() => setChevronIcon(false)}
                  onDoubleClick={async () => {
                    if (!isExtensionCodeFile(file?.fileExtension)) {
                      setCurrentFile(file);
                      setFilePreviewModalState(true);
                    }
                    {
                      const blobObj = await urlToBlob(file?.filePath);
                      const dataString = await blobToString(blobObj);

                      setCodeData({
                        script: dataString,
                        language: getCompilerCodeByExtension(
                          file?.fileExtension
                        ).LanguageCode,
                      });
                      setOpenViewCodeModal(true);
                    }
                  }}
                >
                  {chevronIcon && chevronIcon?.id === file._id && (
                    <div className="absolute top-0 right-0 m-3">
                      <Menu
                        as="div"
                        className="relative inline-block text-left "
                      >
                        <div>
                          <Menu.Button>
                            <div className="flex items-center justify-center h-7 w-7 text-palette_color2 hover:bg-palette_color2 hover:text-palette_color1 hover:rounded-full">
                              <ChevronDownIcon
                                className="w-5 h-5 "
                                aria-hidden="true"
                              />
                            </div>
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items
                            className={
                              index & 1
                                ? "origin-top-center absolute left-[-150px] mt-1 w-44 rounded-md shadow-md shadow-black bg-palette_color2 focus:outline-none z-10"
                                : "origin-top-center absolute left-0 mt-1 w-44 rounded-md shadow-md shadow-black bg-palette_color2 focus:outline-none z-10"
                            }
                          >
                            {isExtensionCodeFile(file?.fileExtension) && (
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active
                                        ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                        : "text-palette_color1",
                                      "block px-4 py-2 text-sm font-robo "
                                    )}
                                    onClick={async () => {
                                      const blobObj = await urlToBlob(
                                        file?.filePath
                                      );
                                      const dataString = await blobToString(
                                        blobObj
                                      );

                                      setCodeData({
                                        script: dataString,
                                        language: getCompilerCodeByExtension(
                                          file?.fileExtension
                                        ).CompilerCode,
                                      });
                                      if (
                                        getCompilerCodeByExtension(
                                          file?.fileExtension
                                        ).CompilerCode === "Not Supported"
                                      ) {
                                        toast.error(
                                          "This language is not supported"
                                        );
                                      } else {
                                        setShowCodeRunModal(true);
                                      }
                                    }}
                                  >
                                    Run
                                  </a>
                                )}
                              </Menu.Item>
                            )}
                            {isExtensionCodeFile(file?.fileExtension) && (
                              <Menu.Item>
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active
                                        ? "bg-palette_color1 text-palette_color2 "
                                        : "text-palette_color1",
                                      "block px-4 py-2 text-sm font-robo "
                                    )}
                                    onClick={async () => {
                                      const blobObj = await urlToBlob(
                                        file?.filePath
                                      );
                                      const dataString = await blobToString(
                                        blobObj
                                      );

                                      setCodeData({
                                        script: dataString,
                                        language: getCompilerCodeByExtension(
                                          file?.fileExtension
                                        ).LanguageCode,
                                      });
                                      setOpenViewCodeModal(true);
                                    }}
                                  >
                                    View
                                  </a>
                                )}
                              </Menu.Item>
                            )}
                            <Menu.Item>
                              {({ active }) => (
                                <a
                                  href="#"
                                  className={classNames(
                                    active
                                      ? "bg-palette_color1 text-palette_color2 "
                                      : "text-palette_color1",
                                    "block px-4 py-2 text-sm font-robo "
                                  )}
                                  onClick={() => {
                                    setCurrentFile(file);
                                    setShareFileModalState(true);
                                  }}
                                >
                                  Share
                                </a>
                              )}
                            </Menu.Item>

                            <Menu.Item>
                              {({ active }) => (
                                <a
                                  href="#"
                                  className={classNames(
                                    active
                                      ? "bg-palette_color1 text-palette_color2 "
                                      : "text-palette_color1",
                                    "block px-4 py-2 text-sm font-robo "
                                  )}
                                  onClick={() => {
                                    if (isInProgress) {
                                      toast.error("Download is in progress", {
                                        theme: "light",
                                      });
                                    } else {
                                      setCurrentFile(file);
                                      download(file.filePath, file.fileOGName);
                                    }
                                  }}
                                >
                                  Download
                                </a>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <a
                                  href="#"
                                  className={classNames(
                                    active
                                      ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                                      : "text-palette_color1",
                                    "block px-4 py-2 text-sm font-robo "
                                  )}
                                  onClick={() => {
                                    setCurrentFile(file);
                                    setDeleteFileBoxState(true);
                                  }}
                                >
                                  Delete
                                </a>
                              )}
                            </Menu.Item>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  )}
                  {/* Folder Icon and Folder name, size Section Start */}
                  <div className="flex flex-col items-center justify-center">
                    {isInProgress && currentFile._id === file._id ? (
                      <>
                        <div className="relative flex flex-row">
                          <div className="flex items-center justify-center">
                            <div className="flex items-center justify-center">
                              <CircularProgressbar
                                className="rounded-full h-9 w-9 "
                                value={percentage}
                                strokeWidth={11}
                                styles={buildStyles({
                                  // pathColor: "turquoise",
                                  // trailColor: "gold",
                                  textSize: "20px",
                                })}
                                //text={`${percentage}%`}
                              />
                            </div>
                            <div
                              className="absolute flex items-center justify-center"
                              onClick={() => cancel()}
                            >
                              <XIcon className="w-5 h-5 cursor-pointer text-icon_color" />
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <Icon
                        {...getFileTypeIconProps({
                          extension: file?.fileExtension,
                        })}
                          className="w-16 h-16 mx-auto cursor-pointer sm:h-20 sm:w-20 md:h-24 md:w-24 "
                      />
                    )}
                    <div className="flex items-center justify-center space-x-1">
                      <h3 className="text-sm  font-robo">
                        {truncate(file?.fileOGName, 20)}
                      </h3>
                    </div>
                    <div className="flex flex-row items-center justify-between space-x-1">
                      <h4 className="  font-robo text-[0.6rem]">
                        <TimeAgo datetime={file?.createdAt} />
                      </h4>
                      <h4 className="  font-robo text-[0.6rem]">
                        {getBytes(file?.fileSize)}
                      </h4>
                    </div>
                  </div>
                  {/* Folder Icon and Folder name, size Section End */}
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center w-full">
                <p className="mt-10 text-xl font-semibold text-primary font-robo">
                  No Files Found
                </p>
                <button
                  className="px-6 py-3 my-3 mb-1 mr-1 text-white uppercase transition-all duration-500 ease-linear rounded shadow-sm  bg-palette_color1 hover:bg-palette_color2 hover:text-palette_color1 font-robo text-md hover:border hover:border-palette_color1 hover:shadow-lg"
                  type="button"
                  onClick={() => setUploadFileModalState(true)}
                >
                  Upload file
                </button>
              </div>
            )}
          </div>
        )}
        {/* File Section End */}
      </div>
    </>
  );
}

export default CodeSpace;
